export interface FamilyPlanStartResult {
    token: string;
    success: boolean;
    familyPlanId: number;
  }

export interface FamilyPlanMemberDto{
  address : string
  addressStatus : AddressStatus
  email : string
  familyPlanAdressUpdate : boolean
  familyPlanId : number
  id : number
  listeningPackageId : number
  memberType : FamilyPlanMemberType
  msisdn : string
  name : string
  remainingDayForAdressUpdate : number
  status : FamilyPlanMemberStatus
  strBirthDate : string
  userId : number
}

export interface FamilyPlanInfoDto{
  familyPlanId : number
  masterMember : FamilyPlanMemberDto
  subMembers : FamilyPlanMemberDto[]
  token : string
}

export interface FamilyPlanMasterInfoDto{
  familyPlanId : number
  masterUserId : number
  msisdn : string
  name : string
  username : string
  toggUser : boolean
}

export interface FamilyPlanMenuItems{
  family: boolean,
  duo: boolean
}

export enum AddressStatus {
  ACTIVE = 1,
  PASSIVE = -1,
  WAITING_FOR_APPROVAL = -2
}

export enum FamilyPlanMemberType {
 MASTER,
 SUB
}

export enum FamilyPlanMemberStatus {
  ACTIVE = 1,
  SUSPEND = -1,
  DEACTIVE = -2
}



// WEBPACK FOOTER //
// src/app/family-plan/family-plan.model.ts